function normalizeBaseOrigin(url) {
  const normalized = String(url || '').trim()
  if (!normalized || normalized === '/') {
    return ''
  }

  return normalized.replace(/\/+$/, '')
}

export function getServiceOrigin() {
  if (import.meta.env.MODE === 'development') {
    return normalizeBaseOrigin(import.meta.env.VITE_BASE_URL || 'http://localhost:5276/')
  }

  return normalizeBaseOrigin(import.meta.env.VITE_BASE_URL)
}

export function getApiBaseUrl() {
  const serviceOrigin = getServiceOrigin()
  return serviceOrigin ? `${serviceOrigin}/api` : '/api'
}

export function buildServiceUrl(path) {
  const rawPath = String(path || '')
  const normalizedPath = rawPath.startsWith('/') ? rawPath : `/${rawPath}`
  const serviceOrigin = getServiceOrigin()

  return serviceOrigin ? `${serviceOrigin}${normalizedPath}` : normalizedPath
}
